import knowledgeBaseAPI from 'dashboard/api/helpCenter/knowledgeBase';
import camelcaseKeys from 'camelcase-keys';

const state = {
  portals: [],
  articles: {
    byId: {},
    allIds: [],
  },
  meta: {
    currentPage: 1,
    articlesCount: 0,
  },
  uiFlags: {
    isFetchingPortals: false,
    isFetching: false,
    isFetchingItem: false,
  },
};

const getters = {
  isFetchingPortals: $state => $state.uiFlags.isFetchingPortals,
  isFetching: $state => $state.uiFlags.isFetching,
  isFetchingItem: $state => $state.uiFlags.isFetchingItem,
  allPortals: $state => $state.portals,
  allArticles: $state => {
    return $state.articles.allIds
      .map(id => $state.articles.byId[id])
      .filter(Boolean);
  },
  articleById: $state => id => $state.articles.byId[id],
  getMeta: $state => $state.meta,
};

const mutations = {
  SET_UI_FLAG($state, flags) {
    $state.uiFlags = { ...$state.uiFlags, ...flags };
  },
  SET_PORTALS($state, portals) {
    $state.portals = portals;
  },
  SET_ARTICLES($state, articles) {
    const byId = {};
    const allIds = [];
    articles.forEach(article => {
      byId[article.id] = article;
      allIds.push(article.id);
    });
    $state.articles.byId = byId;
    $state.articles.allIds = allIds;
  },
  SET_ARTICLE($state, article) {
    $state.articles.byId = {
      ...$state.articles.byId,
      [article.id]: article,
    };
    if (!$state.articles.allIds.includes(article.id)) {
      $state.articles.allIds.push(article.id);
    }
  },
  SET_META($state, meta) {
    $state.meta = meta;
  },
};

const actions = {
  fetchPortals: async ({ commit }) => {
    commit('SET_UI_FLAG', { isFetchingPortals: true });
    try {
      const { data } = await knowledgeBaseAPI.getPortals();
      const portals = camelcaseKeys(data.payload || []);
      commit('SET_PORTALS', portals);
    } catch (error) {
      // silently fail
    } finally {
      commit('SET_UI_FLAG', { isFetchingPortals: false });
    }
  },

  index: async ({ commit }, { page, locale, query, portalId } = {}) => {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await knowledgeBaseAPI.getArticles({
        page,
        locale,
        query,
        portalId,
      });
      const articles = camelcaseKeys(data.payload || []);
      const meta = camelcaseKeys(data.meta || {});
      commit('SET_ARTICLES', articles);
      commit('SET_META', meta);
    } catch (error) {
      // silently fail
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  show: async ({ commit }, { id }) => {
    commit('SET_UI_FLAG', { isFetchingItem: true });
    try {
      const { data } = await knowledgeBaseAPI.getArticle({ id });
      const article = camelcaseKeys(data.payload || {});
      commit('SET_ARTICLE', article);
      return article;
    } catch (error) {
      // silently fail
    } finally {
      commit('SET_UI_FLAG', { isFetchingItem: false });
    }
    return null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
